import React, { useState, useRef, useEffect } from 'react';
import { CloseOutlined, CheckOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { Divider, Empty, Table, Button, Col, Tag, Drawer, Form, Input, InputNumber, Row, Switch, Space, message, Modal, Typography, DatePicker, Select } from 'antd';
import { insert, update, getById, getEstados } from '../../../../apis/RutasApi';
import { conceptos_sat } from '@app/constants/concepto';
import dayjs from 'dayjs';
import _ from 'lodash';
import axios from 'axios';

const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;
const App = ({ title, id, open, finish }) => {
    const [form] = Form.useForm()
    const [ID, setID] = useState(id);
    const [modified, setModified] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [estados, setEstados] = useState([]);


    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        let success = false;
        if (ID > 0) {
            //Update
            const payload = {
                id: ID,
                ...fields
            }
            const response = await update(payload);
            success = response.ok;
            if (response.ok) {
                message.success('Se actualizó correctamente la ruta!');
            }
        } else {
            //Create
            const payload = {
                id: ID,
                ...fields
            }
            const response = await insert(payload);
            success = response.ok;
            if (response.ok) {
                setID(response.payload);
                message.success('Se guardo correctamente la ruta!');
            }
        }

        if (success) {
            finish(true, true);
        }
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                if (ID > 0) {
                    await refreshData();
                } else {
                    setInitialValues({
                        ruta: null,
                        descripcion: null,
                        estado: null,
                        ciudad: null,
                        codigo_postal: null,
                        activo: true
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);

    const refreshData = async () => {
        const response = await getById(ID);
        if (response.ok) {
            let item = response.payload;
            if (item.fecha) {
                item.fecha = dayjs(item.fecha, 'YYYY-MM-DD');
            }
            setInitialValues(item);
        }
    }


    useEffect(() => {
        const getEstado = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_SERVER}estados/estados`);
                // Convertimos el objeto a un arreglo
                console.log(response.data);

                setEstados(response.data);
            } catch (error) {

                console.error('Error:', error);
            }
        };

        getEstado();
    }, []);


    const onChangeEstado = (value) => {
        console.log('Estado seleccionado:', value);
    };

    const onClose = (reload) => {
        finish(reload ?? modified);
        setInitialValues(null);
        setShowModal(false);
    }

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    return (
        <Drawer
            title={title}
            width={720}
            placement={"right"}
            onClose={onClose}
            open={open}
            closable={true}
            extra={<Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                    Guardar
                </Button>
            </Space>}
        >
            <>
                <div>
                    <div style={{ float: 'left' }}>
                        <span title=""></span>
                    </div>
                    <span class="" style={{ float: 'right' }}>

                    </span>
                </div>
                {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                    Guardar
                    </Button>
                </Space>]} />*/}
                {
                    initialValues &&
                    <Form
                        layout="vertical"
                        form={form}
                        requiredMark
                        autoComplete="off"
                        initialValues={initialValues}
                        onFinish={handleOk}>
                        <Row gutter={16}>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="ruta"
                                    label="Ruta"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega un valor',
                                        },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega la ruta" />
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="descripcion"
                                    label="Descripción"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega una descripción',
                                        },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega una descripción" />
                                </Form.Item>
                            </Col>
                            {/* <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="estado"
                                    label="Estado"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Por favor agrega el estado',
                                        },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega el estado" />
                                </Form.Item>
                            </Col> */}
                            {estados && estados.length > 0 && (
                                <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    <Form.Item
                                        name="estado"
                                        label="Estado"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Por favor selecciona un estado',
                                            },
                                        ]}
                                    >
                                        <Select
                                            placeholder="Por favor selecciona un estado"
                                            showSearch
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            onChange={onChangeEstado}
                                        >
                                            <Option value="">Ninguno</Option>
                                            {estados.map((item) => (
                                                <Option key={item.codigo} value={item.codigo}>
                                                    {item.nombre}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            )}
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="ciudad"
                                    label="Ciudad"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega el nombre de la ciudad',
                                        },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega el nombre de la ciudad" />
                                </Form.Item>
                            </Col>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="codigo_postal"
                                    label="Codigo Postal"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Por favor agrega un código postal',
                                        },
                                    ]}
                                >
                                    <InputNumber placeholder="Por favor agrega un código postal" />
                                </Form.Item>
                            </Col>

                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Form.Item
                                    name="activo"
                                    label="Activo"
                                >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                }
            </>
        </Drawer>
    );
};
export default App;